// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {ApolloQueryResult} from 'apollo-client';
import * as React from 'react';
import {useState} from 'react';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';

import {
  EntityIntegrationsQuery,
  EntityQuery,
  useDeleteIntegrationMutation,
} from '../../generated/graphql';
import {
  extractErrorMessageFromApolloError,
  propagateErrorsContext,
} from '../../util/errors';
import {InstrumentedLoader as Loader} from '../utility/InstrumentedLoader';

type DeleteGenericWebhookIntegrationModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  webhookIntegrationID: string;
  webhookIntegrationName: string;
  entityRefetch?: () =>
    | Promise<ApolloQueryResult<EntityQuery>>
    | Promise<ApolloQueryResult<EntityIntegrationsQuery>>;
};

export const DeleteGenericWebhookIntegrationModal = ({
  isOpen,
  closeModal,
  webhookIntegrationID,
  webhookIntegrationName,
  entityRefetch,
}: DeleteGenericWebhookIntegrationModalProps) => {
  const [deleteIntegrationMutation] = useDeleteIntegrationMutation({
    context: propagateErrorsContext(),
  });
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  return (
    <Modal
      className="webhooks--delete-modal"
      open={isOpen}
      onClose={closeModal}>
      <Modal.Header style={{overflowWrap: 'break-word'}}>
        Delete webhook "{webhookIntegrationName}"?
      </Modal.Header>
      <Modal.Content>
        <p>
          Deleting this webhook permanently disrupts associated integrations.
          Proceed with caution.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button variant="ghost" onClick={closeModal} className="mr-8">
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={async () => {
            setIsDeleteLoading(true);
            try {
              if (webhookIntegrationID !== '') {
                await deleteIntegrationMutation({
                  variables: {
                    id: webhookIntegrationID,
                  },
                });
                entityRefetch?.();
              }
            } catch (errors) {
              const errMsg = extractErrorMessageFromApolloError(errors);
              toast(`There was an error deleting your webhook: ${errMsg}`, {
                type: 'error',
              });
            }
            setIsDeleteLoading(false);
            closeModal();
          }}>
          {isDeleteLoading ? (
            <Loader
              inline
              size="tiny"
              active
              name="webhooks--table-delete-row"
            />
          ) : (
            'Delete'
          )}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
